import { z } from 'zod'
export const internshipDetailsSearchSchema = z.object({
  tab: z.enum(['interns', 'program', 'survey', 'groups', 'agreements']).catch('interns'),
  search: z.string().max(200).catch(''),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z.enum(['lastname', 'group', 'org', 'eduSupervisor', 'records']).catch('lastname'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})
export type InternshipDetailsSearch = z.infer<typeof internshipDetailsSearchSchema>
export const defaultInternshipDetailsSearch: InternshipDetailsSearch = {
  tab: 'interns',
  search: '',
  page: 1,
  pageSize: 25,
  sortBy: 'lastname',
  direction: 'asc',
}
